"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGiftCard = createGiftCard;
exports.createGiftCardAssign = createGiftCardAssign;
exports.getGiftCard = getGiftCard;
exports.getGiftCardAssignPage = getGiftCardAssignPage;
exports.getGiftCardCirculationLog = getGiftCardCirculationLog;
exports.getGiftCardMemberPage = getGiftCardMemberPage;
exports.getGiftCardPage = getGiftCardPage;
exports.giftCardAssginMemberList = giftCardAssginMemberList;
exports.giftCardAudit = giftCardAudit;
exports.giftCardCheck = giftCardCheck;
exports.updateGiftCard = updateGiftCard;
exports.updateMemberCardImage = updateMemberCardImage;
exports.uploadGiftCardImage = uploadGiftCardImage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyGiftCard';
// 校对
function giftCardCheck(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/check',
    method: 'put',
    data: data
  });
}

// 审核
function giftCardAudit(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/audit',
    method: 'put',
    data: data
  });
}

// 礼品卡发放人员
function giftCardAssginMemberList(fnId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/assignMemberList/' + fnId,
    method: 'get'
  });
}

// 礼品卡发放
function createGiftCardAssign(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/assign',
    method: 'post',
    data: data
  });
}

// 礼品卡发放列表
function getGiftCardAssignPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/assignPage',
    method: 'get',
    params: query
  });
}

// 获取礼品卡分页列表
function getGiftCardPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取礼品卡
function getGiftCard(id) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/' + id,
    method: 'get'
  });
}

// 创建礼品卡
function createGiftCard(data) {
  return (0, _requestPIM.default)({
    url: requestUrl,
    method: 'post',
    data: data
  });
}

// 更新礼品卡
function updateGiftCard(data) {
  return (0, _requestPIM.default)({
    url: requestUrl,
    method: 'put',
    data: data
  });
}

// 礼品卡持卡列表（所有用户的卡片实例）
function getGiftCardMemberPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/memberPage',
    method: 'get',
    params: query
  });
}

// 礼品卡流转记录（溯源）
function getGiftCardCirculationLog(assignMemId) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/circulationLog/' + assignMemId,
    method: 'get'
  });
}

// 更新持卡记录卡面图片
function updateMemberCardImage(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/memberCardImage',
    method: 'put',
    data: data
  });
}

// 上传图片
function uploadGiftCardImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestPIM.default)({
    url: requestUrl + '/uploadImage',
    method: 'post',
    data: formData
  });
}